<dgx-modal
  bodyClasses="guts-p-t-0 "
  [canCancel]="true"
  [isHeaderBorderless]="false"
  [isPendingWithOverlay]="true"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
  [isLoading]="loading"
>
  <ng-container class="modal-header">
    {{ headerText }}
  </ng-container>
  <ng-container class="modal-body">
    <div class="guts-p-full-1">
      <df-local-notification
        [type]="NotificationType.warning"
        [text]="i18n.OrgPlans_CustomTitlesAndDescriptionsNotLocalized"
        size="small"
      ></df-local-notification>
    </div>

    <form
      role="form"
      [formGroup]="form"
      class="form-wrap guts-p-h-1"
      (ngSubmit)="submit()"
    >
      <df-form-root
        [form]="form"
        [options]="options"
        [model]="model"
        [fields]="fields"
      ></df-form-root>
    </form>
  </ng-container>
  <ng-container class="modal-footer">
    <button
      type="submit"
      df-button
      dfButtonType="primary"
      data-dgat="orgAddPageModal-6ca"
      (click)="submit()"
      [disabled]="form.invalid && form.touched"
    >
      <df-spinner-button [isSpinning]="isSubmitting">
        {{ submitButtonText }}
      </df-spinner-button>
    </button>
  </ng-container>
</dgx-modal>

<ng-template #planPurpose let-formControl="formControl" let-params="params">
  <dgx-select
    id="purpose"
    [hasError]="formControl.touched && formControl.invalid"
    [isRequired]="params.required"
    [options]="purposeSelect"
    [ariaLabel]="i18n.OrgPlans_Purpose"
    [selectedItem]="showSelectedPurpose ? undefined : target.targetType"
    (blur)="formControl.markAsTouched()"
    (selection)="onPurposeTypeChange($event, formControl)"
    class="full-width"
    dgatInput="target-settings-form-62f"
  ></dgx-select>
</ng-template>

<ng-template
  #suggestTitleInput
  let-formControl="formControl"
  let-ariaDescribedby="params.ariaDescribedby"
  let-params="params"
>
  <dgx-plan-title-search
    [defaultValue]="params.defaultValue"
    [autofocus]="params.autofocus"
    (selection)="onItemsFieldChange($event, formControl)"
    [target]="target"
  ></dgx-plan-title-search>
</ng-template>

<ng-template #subTitle>
  <div class="guts-p-v-1">
    <label class="df-form__label" for="subtitle">
      {{ i18n.OrgPlans_Subtitle }}
      <df-icon
        [ngbTooltip]="i18n.OrgPlans_SubtitleTooltip"
        placement="top"
        attr.aria-label="{{ i18n.OrgPlans_SubtitleTooltip }}"
        class="color-ebony-a61 guts-p-h-quart"
        icon="info"
        size="small"
      ></df-icon>
    </label>
    <input
      type="text"
      name="subtitle"
      [(ngModel)]="target.subtitle"
      maxlength="255"
      placeholder="{{ i18n.OrgPlans_SubtitlePlaceholder }}"
      data-dgat="targetSettingsForm-db4"
    />
  </div>
</ng-template>

<ng-template #description let-formControl="formControl" let-params="params">
  <dgx-markdown-editor
    class="guts-m-b-half height-auto"
    name="editRowDescription"
    [(ngModel)]="target.description"
    [minHeight]="'150px'"
    [maxLength]="1950"
    [placeholder]="descriptionPlaceholderText"
    [required]="params.required"
    [textareaId]="'editRowDescription'"
    [textareaLabel]="'editRowDescription'"
    (ngModelChange)="onDescriptionChange(target.description, formControl)"
    ngDefaultControl
    data-dgat="targetSettingsForm-e5d"
  ></dgx-markdown-editor>
</ng-template>

<ng-template #imageUploader>
  <div class="guts-p-v-1">
    <dgx-upload-section
      [imageUrl]="target.imageUrl"
      [uploadAdapter]="uploadAdapter"
      [isImageUrlFallbackImage]="target.isImageUrlFallbackImage"
      (uploadSuccessEvent)="onImageUploadSuccess($event)"
      (deleteEvent)="onDeleteImage()"
      [useCropper]="true"
      [aspectRatio]="16 / 9"
    >
    </dgx-upload-section>
  </div>
</ng-template>

<ng-template #type>
  <fieldset class="guts-p-v-1">
    <legend
      class="form__label font-semibold"
      [textContent]="i18n.OrgPlans_Type"
    ></legend>
    <div
      *ngFor="let option of targetTypeOptions"
      class="selection-box"
      data-dgat="orgAddEditPlan-7e6"
      [ngClass]="{ is_disabled: option.disabled }"
    >
      <label class="selection-box__label" for="{{ option.id }}">
        <input
          id="{{ option.id }}"
          type="radio"
          name="targetType"
          class="selection-box__radio"
          [value]="option.id"
          [(ngModel)]="model.type"
          (change)="onTypeChange(option.id)"
          class="guts-m-r-1"
          data-dgat="targetSettingsForm-33e"
          [disabled]="option.disabled"
        />
        <span
          class="selection-box__text par--small"
          [textContent]="option.label"
        ></span>
      </label>
    </div>
  </fieldset>
</ng-template>

<ng-template #primaryContact>
  <div class="guts-p-v-1">
    <label class="guts-m-b-quart font-strong" for="user-search">{{
      i18n.FlexCtrl_PrimaryContact
    }}</label>
    <dgx-user-search
      [usersOnly]="true"
      [ariaLabel]="'Core_Collaborator' | translate"
      [recipients]="target.primaryContact ? [target.primaryContact] : []"
      (selectRecipient)="onPrimaryContactSelect($event)"
      (removeRecipient)="onPrimaryContactRemove()"
    ></dgx-user-search>
  </div>
</ng-template>

<ng-template #visibility>
  <fieldset class="guts-p-v-1">
    <legend
      class="form__label font-semibold"
      [textContent]="i18n.TargetForm_Visibility"
    ></legend>
    <div
      class="selection-box"
      *ngFor="let option of privacyOptions"
      data-dgat="orgAddEditPlan-00b"
      [ngClass]="{ is_disabled: !option.enabled }"
    >
      <label class="l_flex m-l_flex selection-box__label">
        <div class="l_flex-grow">
          <input
            class="selection-box__radio"
            type="radio"
            name="visibility"
            [value]="option.id"
            [(ngModel)]="target.privacyId"
            data-dgat="targetSettingsForm-4e9"
            [disabled]="!option.enabled"
          />
          <span
            class="selection-box__text par--small"
            [textContent]="option.name"
          ></span>
        </div>
        <div *ngIf="option.canExpand">
          <df-icon
            *ngIf="target.privacyId !== option.id"
            icon="chevron-down"
            size="small"
          ></df-icon>
          <df-icon
            *ngIf="target.privacyId === option.id"
            icon="chevron-up"
            size="small"
          ></df-icon>
        </div>
      </label>
      <div
        *ngIf="
          !isDirectory &&
          option.id === 2 &&
          target.privacyId === 2 &&
          option.canExpand
        "
        class="selection-box__extras guts-p-h-2 m-guts-p-t-1"
        [@dfCollapseExpand]
      >
        <dgx-group-visibility
          [readOnly]="limitOrgPublish"
          [includeAll]="true"
          [groupIds]="groupIds"
          [groupNames]="groupNames"
          [required]="true"
          [customTitle]="i18n.PathwayPrivacyModal_OnlySetGroups"
          [hideLabel]="true"
          [selectCallback]="handleGroupsAdd"
          [deselectCallback]="handleGroupsRemove"
        ></dgx-group-visibility>
      </div>
      <div
        *ngIf="option.id === 1 && target.privacyId === 1 && option.canExpand"
        class="selection-box__extras guts-p-h-2 m-guts-p-t-1"
        [@dfCollapseExpand]
      >
        <dgx-group-visibility
          [includeUsersGroups]="true"
          [readOnly]="limitOrgPublish"
          [groupNames]="groupNames"
          [groupIds]="groupIds"
          [customTitle]="
            i18n.orgInternalContentVisibilitySelector_TargetGroupsLabel
          "
          [selectCallback]="handleGroupsAdd"
          [deselectCallback]="handleGroupsRemove"
          [excludedPrivacyLevels]="excludedGroupPrivacyLevels"
        ></dgx-group-visibility>
      </div>
    </div>
  </fieldset>
</ng-template>

<!-- Auto populate plan switch -->
<ng-template #autoPopulateToggleSwitch>
  <div class="guts-p-v-1">
    <div class="l_flex l_flex-middle">
      <div class="l_flex-grow">
        <label
          class="font-semibold block guts-m-b-quart"
          [textContent]="i18n.TargetForm_AutopopulateTitle"
          for="AutopopulateCheckbox"
        ></label>
        <span
          class="par par--small"
          [textContent]="i18n.TargetForm_AutopopulateInfo"
        ></span>
      </div>
      <dgx-toggle-switch
        [isChecked]="autoPopulate"
        (toggled)="handleToggle($event, 'autoPopulate')"
        id="AutopopulateCheckbox"
        data-dgat="targetSettingsForm-9db"
      ></dgx-toggle-switch>
    </div>
  </div>
</ng-template>

<!-- Endorse plan switch -->
<ng-template #endorsePlanToggleSwitch>
  <div class="guts-p-v-1">
    <div class="l_flex l_flex-middle">
      <div class="l_flex-grow guts-m-r-1">
        <label
          class="block font-semibold guts-m-b-quart"
          [textContent]="i18n.TargetForm_IsEndorsedTitle"
          for="IsEndorsedCheckbox"
        ></label>
        <span
          class="par par--small"
          [textContent]="i18n.TargetForm_IsEndorsedInfo"
        ></span>
      </div>

      <dgx-toggle-switch
        [isChecked]="target.isEndorsed"
        (toggled)="handleToggle($event, 'isEndorsed')"
        id="IsEndorsedCheckbox"
        data-dgat="targetSettingsForm-87c"
      ></dgx-toggle-switch>
    </div>
  </div>
</ng-template>
